import { InternalInformationSentryError } from "./SentryErrors";

//https://empsgourp.atlassian.net/browse/VGF-14170 - websocket codes are taken from there
const logErrorOnWSCodesRange: { min: number, max: number; } = { min: 1000, max: 3999 };

const logErrorOnWSCodes: number[] = [
	4000,
	4004,
	4005,
	4006,
	4007,
	4011,
];

const dontLogErrorOnWSCodes: number[] = [
	1001,
	1006,
	4001,
	4002,
	4008,
	4009,
	4010,
	4012,
];

export class SentryInternalInformationDisconnect {
	public static MESSAGE = "Internal Information: Disconnect";
	public static FINGERPRINT = "internal-information-disconnect";

	public static shouldLogError(lastWSCode: number): boolean {
		if (typeof lastWSCode !== "number") {
			return true; //if lastWSCode is not a number and we still got Internal Information: Disconnect, then something went wrong and we want to log it
		}
		if (logErrorOnWSCodes.includes(lastWSCode)) {
			return true;
		}
		if (dontLogErrorOnWSCodes.includes(lastWSCode)) {
			return false;
		}
		if (lastWSCode >= logErrorOnWSCodesRange.min && lastWSCode <= logErrorOnWSCodesRange.max) {
			return true;
		}
		return false;
	}

	public static createInternalInformationError(): InternalInformationSentryError {
		return {
			message: SentryInternalInformationDisconnect.MESSAGE,
			fingerprint: SentryInternalInformationDisconnect.FINGERPRINT
		};
	}
}